/**
 * Mapa de ícones de features para Landing
 */

import peaceIcon from "../../assets/pombo-white.png";
import growIcon from "../../assets/grow.png";
import heartIcon from "../../assets/heart.png";
import starIcon from "../../assets/star.png";

export const featureIconMap: Record<string, string> = {
  "1": peaceIcon,
  "2": growIcon,
  "3": heartIcon,
  "4": starIcon,
};

export default featureIconMap;
